import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import { licenceApi } from "../../services/licence.api";
import { LicenceResponse } from "../../types/licence.definition";
import {
  fetchLicenceFailure,
  fetchLicenceRequest,
  fetchLicenceSuccess,
} from "../reducers/licenceSlice";

function* fetchLicenceSaga({
  payload,
}: PayloadAction<{ facilityId: number }>): Generator<unknown, void, LicenceResponse> {
  try {
    const licence = yield call(licenceApi.getLicenceByFacility, payload.facilityId);
    yield put(fetchLicenceSuccess(licence));
  } catch (error) {
    const err = error as { code?: string; message?: string };
    yield put(fetchLicenceFailure({
      code: err.code ?? "UNEXPECTED_ERROR",
      message: err.message ?? "Failed to load licence",
    }));
  }
}

export function* watchLicence() {
  yield takeLatest(fetchLicenceRequest.type, fetchLicenceSaga);
}
